// Core Firebase setup
export * from './firebase-setup';

// Export types from firebase/firestore
export type {
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  QueryDocumentSnapshot,
  QuerySnapshot,
  CollectionReference,
  Query,
  FieldValue,
  Timestamp,
  WhereFilterOp,
  OrderByDirection,
  DocumentChange,
  DocumentChangeType,
  Firestore as FirebaseFirestore,
  FirestoreError,
  QueryConstraint,
  Unsubscribe,
  WriteBatch,
  Transaction,
} from 'firebase/firestore';

// Export types from firebase/auth
export type {
  User as FirebaseUser,
  UserInfo,
  UserMetadata,
  UserCredential,
  Auth,
  AuthProvider,
  AuthError,
} from 'firebase/auth';

// Export types from firebase/storage
export type {
  FirebaseStorage,
  StorageReference,
  UploadResult,
  UploadTask,
  UploadTaskSnapshot,
  StorageError,
  ListResult,
} from 'firebase/storage';

// Export custom types and utilities
export type { 
  FirebaseConfig, 
  FirebaseServices, 
  FirebaseError,
  WithId
} from './types';

export type { 
  QueryOptions,
  WhereClause,
  OrderByClause 
} from './types/query-options';

// Export firestore operations and types
export * from './firestore-operations';

// React hooks
export * from './hooks/useFirestore';
